import React from 'react'
import FlowPic from "../../img/img-6.png";

function Flow() {
  return (
    <section className="text-[#244566] bg-[#e9eef4] flex flex-col justify-center items-center space-y-14 pt-12 pb-14">
      <h3 className="text-2xl font-semibold">OUR PROCESS FLOW</h3>
      <img alt="" src={FlowPic} className="w-[90%] lg:w-[70%] xl:w-[60%]" />
    </section>
  )
}

export default Flow